<template>
  <div
    :style="{ backgroundColor: statusColor || 'gray' }"
    :class="[
      s.status,
      s[`d_${helper.displayDirection}`],
      helper.isNative.app ? s.isNative : '',
    ]">
    <div :class="s.left">
      <div v-if="user.role?.role !== 13">{{ user.vehicles[0]?.label || '車両未設定' }}</div>

      <!-- 緊急の時は何も表示しない -->
      <div v-if="user.driverStatus.name === 'emergency'">----</div>
      <div v-else>{{ user.driverStatus.status || '不明' }}</div>

      <div v-if="showWaitingLabel"> {{ getWaitingLabel() }}</div>
      <div v-if="assignedDemand(user)">{{ assignedDemand(user).label }}</div>
    </div>
    <div :class="s.buttons">
      <button
        :class="s.finish_work"
        :style="{ backgroundColor: statusColor || 'gray' }"
        @click="logout"
        v-if="user.login.isLogin && user.flag === 1"><i class="fa-solid fa-right-from-bracket"></i></button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import cf from '@/mixins/commonFunctions';

export default {
  name: 'DriverStatus',
  mixins: [cf],
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapState(['user', 'helper']),
    statusColor() {
      const officeId = this.user.offices?.[0]?.id;
      return this.getStatusHex(officeId, this.user.driverStatus?.name);
    },
    showWaitingLabel() {
      return this.user.offices[0]?.name !== 'takasakiSakura';
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('user/login/logout');
    },
    // 業務開始時にuser.flagを1に変更
    endWork() {
      cf.ToggleNativeAppLocation(this.helper, 2);
      this.$store.dispatch('user/updateFlag', 2);
    },
    getWaitingLabel() {
      const waitingRecord = (this.user.waitingDriver || []).find((wd) => wd.type === 1 && !wd.end_at);
      if (!waitingRecord) {
        return '';
      }
      const taxiStandLabel = waitingRecord.taxiStand?.label || '';
      const waitingDrivers = waitingRecord.taxiStand?.waitingDrivers || [];
      const nowIndex = waitingDrivers.findIndex((d) => d.driver_id === this.user.id);
      if (taxiStandLabel && nowIndex !== -1) {
        return ` (${taxiStandLabel}: ${nowIndex + 1}番目)`;
      }
      return '';
    },
  },
};
</script>

<style lang="scss" module="s">
.status {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: var(--status-height);
  color: #ffffff;
  font-weight: bold;
  font-size: 24px;
  padding: 0 0 0 12px;
  z-index: 10;

  .left {
    display: flex;
    align-items: center;
    > :not(:first-child) {
      margin-left: 8px;
    }
  }
}

.buttons {
  height: 100%;
  > * {
    border: none;
    background-color: transparent;
    padding: 0 16px;
    height: 100%;
    font-weight: bold;
    border-radius: 4px;
    &.finish_work {
      color: white;
    }
  }
}
</style>
